import { ReactElement } from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import TextField from '@mui/material/TextField';
import CustomFormControl from './CustomFormControl';
import RequiredIndicator from 'pages/ApplicationRequest/components/containers/RequiredIndicator';
import { BEM_NAME_ELEMENTS } from 'pages/NewNonEmployee/_const';

/**
 * customized field prompting user for text input
 * @param {string|ReactElement} helperText default on-screen assistance
 * @param {boolean} required if required, display an indicator
 * @param {string|ReactElement} label label to display
 * @param {any} props properties to be passed to the textfield
 * @returns {ReactElement} textfield prompting for user input
 */
const CustomTextField = ({ helperText, required, label, ...props }) => {
	const [field, meta] = useField(props);

	return (
		<CustomFormControl>
			<TextField
				id={`${BEM_NAME_ELEMENTS.VIEW_FORM}__${BEM_NAME_ELEMENTS.FIELD_TEXT_FIELD}--${props.name}`}
				variant='outlined'
				label={
					<>
						{required && <RequiredIndicator />}
						{label}
					</>
				}
				helperText={
					meta.touched && meta.error ? meta.error : helperText
				}
				error={meta.touched && !!meta.error}
				{...props}
				{...field}
			/>
		</CustomFormControl>
	);
};

CustomTextField.propTypes = {
	helperText: PropTypes.string,
	label: PropTypes.string.isRequired,
	required: PropTypes.bool,
	name: PropTypes.string.isRequired,
};

export default CustomTextField;
